import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.3299 6.7059L17.2474 3.61223C16.8451 3.23297 16.3179 3.01535 15.7661 3.00078C15.2143 2.98621 14.6765 3.1757 14.2549 3.5332L4.12974 13.6949C3.7661 14.0629 3.53968 14.5453 3.48848 15.061L3.00473 19.7693C2.98957 19.9347 3.01095 20.1014 3.06735 20.2575C3.12374 20.4136 3.21376 20.5553 3.33098 20.6726C3.4361 20.7772 3.56077 20.86 3.69784 20.9162C3.83491 20.9724 3.98168 21.0008 4.12974 21H4.23099L8.92229 20.5709C9.4362 20.5196 9.91684 20.2923 10.2836 19.9274L20.4087 9.76569C20.8017 9.34902 21.014 8.793 20.9993 8.21946C20.9845 7.64592 20.7438 7.10164 20.3299 6.7059ZM8.71979 18.3128L5.34475 18.6289L5.64851 15.2417L12.0048 8.94146L15.0424 11.99L8.71979 18.3128ZM16.5049 10.477L13.4898 7.45108L15.6836 5.19293L18.7549 8.27531L16.5049 10.477Z",
		fill: "currentColor"
	})
});
export default SvgIconEdit;
